// @flow
import * as React from 'react';

import { ScaleContext } from './ScaleContext';

type Props = {
  preferedMinWidth: number,
  preferedMinHeight: number,
  preferedWidth: number,
  preferedHeight: number,
  children: React.Node,
  className?: string,
  onScaleChange?: number => void,
};

type State = {
  scale: number,
  offsetLeft: number,
};

class AutoScaleContainer extends React.Component<Props, State> {
  static defaultProps = {
    preferedMinWidth: 0,
    preferedMinHeight: 0,
  };

  viewportDiv: ?HTMLDivElement;

  constructor(props: Props) {
    super(props);
    this.state = {
      scale: 1,
      offsetLeft: 0,
    };

    (this: any).calculateScale = this.calculateScale.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.calculateScale);
    requestAnimationFrame(() => {
      this.calculateScale();
    });
    this.calculateScale();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateScale);
  }

  calculateScale(): void {
    if (!this.viewportDiv) return;

    const viewportWidth = this.viewportDiv.clientWidth;
    const viewportHeight = this.viewportDiv.clientHeight;

    let scale = Math.max(viewportWidth / this.props.preferedWidth, viewportHeight / this.props.preferedHeight);

    if (viewportWidth / scale < this.props.preferedMinWidth) {
      scale = viewportWidth / this.props.preferedMinWidth;
    }

    if (viewportHeight / scale < this.props.preferedMinHeight) {
      scale = viewportHeight / this.props.preferedMinHeight;
    }

    const offsetLeft = (viewportWidth - this.props.preferedWidth * scale) / 2;

    if (this.state.scale !== scale || this.state.offsetLeft !== offsetLeft) {
      this.setState({ scale, offsetLeft });
      if (this.props.onScaleChange) this.props.onScaleChange(scale);
    }
  }

  render() {
    const viewportInnerStyle = {
      position: 'absolute',
      bottom: 0,
      margin: 'auto',
      width: `${this.state.scale * this.props.preferedWidth}px`,
      height: `${this.state.scale * this.props.preferedHeight}px`,
      transform: `translate3d(${this.state.offsetLeft}px, 0, 0)`,
    };

    const classes = ['pizza-viewport'];
    if (this.props.className) classes.push(this.props.className);

    return (
      <div
        className={classes.join(' ')}
        ref={dom => {
          this.viewportDiv = dom;
        }}
      >
        <div className="pizza-viewport-inner" style={viewportInnerStyle}>
          <ScaleContext.Provider value={this.state.scale}>{this.props.children}</ScaleContext.Provider>
        </div>
      </div>
    );
  }
}

export default AutoScaleContainer;
